import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import CarousalCard from "./CarousalCard";
import Slider from "react-slick";

import "./ImageTextCarousal.scss";


const ImageTextCarousal = ({Module, strapi_id}) => {

    var settings = {
        dots: false,
        arrows: true,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    arrows: true,
                    dots: true,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    arrows: false,
                    dots: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };


    return (
        <>
            <section className={"image_text_carousal"}>
                <Container>
                    <Row>
                        <Col>
                            <h2>{(Module?.heading_text)}</h2>

                            {Module?.image_text_carousel_module?.length > 0 && 
                                <Slider {...settings}>
                                    {Module?.image_text_carousel_module?.map((item, index) => (
                                        <CarousalCard key={index} item={item} strapi_id={strapi_id} />
                                    ))}
                                </Slider>
                            }
                        </Col>
                    </Row>
                </Container>
            </section>

        </>
    );
};
export default ImageTextCarousal;